export default {
  namespaced: true,
  state: {
    isDarkMode: false,
    segmentsColors: [
      {
        id: 7,
        color: "#666429", // Cinnabar
      },
      {
        id: 5,
        color: "#3357FF",
      },
      {
        id: 13,
        color: "#38aa4c", // Royal Blue
      },
      {
        id: 6,
        color: "#d4683d",
      },
      {
        id: 4,
        color: "#A133FF", // Electric Violet
      },
      {
        id: 8,
        color: "#36a9a1",
      },
      {
        id: 14,
        color: "#FFA133", // Carrot Orange
      },
      {
        id: 9,
        color: "#33A1FF", // Picton Blue
      },
      {
        id: 10,
        color: "#57FF33", // Lime Green
      },
      {
        id: 11,
        color: "#FFD700", // Gold
      },
      {
        id: 12,
        color: "#6f88bc", // Dark Turquoise
      },
    ],
  },
  getters: {
    segmentsColors: (state) => state.segmentsColors,
  },
  actions: {
    turnOnDarkMode({ commit }) {
      commit("turnOnDarkMode");
    },
    turnOffDarkMode({ commit }) {
      commit("turnOffDarkMode");
    },
  },
  mutations: {
    turnOnDarkMode(state) {
      state.isDarkMode = true;
    },
    turnOffDarkMode(state) {
      state.isDarkMode = false;
    },
  },
};
